module.exports = __webpack_public_path__ + "static/img/solution (1).f6feea01.png";